import { BaseModel } from '../../../../../../core/_base/crud';

export class DoiTraHang extends BaseModel {

    static thanhPhamId = 4;
    static category_path = "DTH";

    static optionsTinhTrang = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'DTH_PHIEUMOI',
        },
        {
            id: 3,
            name: 'Chờ duyệt',
            value: 'DTH_CHODUYET',
        },
        {
            id: 4,
            name: 'Không duyệt',
            value: 'DTH_KHONGDUYET',
        },
        {
            id: 5,
            name: 'Hoàn tất',
            value: 'DTH_HOANTAT',
        },
        {
            id: 6,
            name: 'Đã hủy',
            value: 'DTH_DAHUY',
        },
        {
            id: 6,
            name: 'Đã xóa',
            value: 'DTH_DAXOA',
        },
    ];

    Id: number
    
    GhiChu: string
    NguoiTao: number
    TenNguoiTao: string
    NgayTao: string
    SoPhieu: string
    TinhTrang: string
    TenTinhTrang: string
    listDetail: DoiTraHangCt[]
    numChoDuyet: number
    numDuocDuyet: number
    numKhongDuocDuyet: number
    IsEnable_Duyet: boolean
    IsVisible_Duyet: boolean
    NguoiDuyet: string
    NgayDuyet: string
    LyDoDuyet: string
    GiaoBu: string
    clear() {
        this.Id = 0;
        this.GhiChu = '';
        this.NguoiTao = 0;
        this.TenNguoiTao = '';
        this.NgayTao = '';
        this.SoPhieu = '';
        this.TinhTrang = '';
        this.TenTinhTrang = '';
        this.listDetail = [];
        this.numChoDuyet = 0;
        this.numDuocDuyet = 0;
        this.numKhongDuocDuyet = 0;
        this.IsEnable_Duyet = false;
        this.IsVisible_Duyet = false;
        this.GiaoBu = '';
    }
    copy(item: DoiTraHang) {
        this.Id = item.Id;
        this.GhiChu = item.GhiChu;
        this.NguoiTao = item.NguoiTao;
        this.TenNguoiTao = item.TenNguoiTao;
        this.NgayTao = item.NgayTao;
        this.SoPhieu = item.SoPhieu;
        this.TinhTrang = item.TinhTrang;
        this.TenTinhTrang = item.TenTinhTrang;
        this.listDetail = item.listDetail;
        this.numChoDuyet = item.numChoDuyet;
        this.numDuocDuyet = item.numDuocDuyet;
        this.numKhongDuocDuyet = item.numKhongDuocDuyet;
        this.IsEnable_Duyet = item.IsEnable_Duyet;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.GiaoBu = item.GiaoBu;
    }
}
export class DoiTraHangCt extends BaseModel {

    static category_path = "DTH_DETAIL";
    static DEFAULT_NUMBER_VALUE = "0,00";
    static DEFAULT_QUANNITY_VALUE = "1,00";
    static DEFAULT_NUMBER_VALUE_NUMBER = "0.00";

    Id: number
    DoiTraHangId: number
    IdKh: number
    MaKH: string
    TenKH: string
    HangHoaId: number
    MaHH: string
    TenHH: string
    QuyCach: string
    SoLuongDoi: number
    SoLuongDeXuat: number
    Dvt: number
    HanSuDung: string
    SoLo: string
    DonViTinh: string
    GhiChu: string
    GiaBan: number
    ThanhTien: number
    HuongXuLy: string
    HangHoaKemTheoId: number
    MaHHKemTheo: string
    TenHHKemTheo: string
    IsEnable_Duyet: boolean
    IsVisible_Duyet: boolean
    isDone: boolean
    ThamChieu: string 
    clear() {
        this.Id = 0;
        this.DoiTraHangId = 0;
        this.HangHoaId = 0;
        this.MaHH = '';
        this.TenHH = '';
        this.QuyCach = '';
        this.SoLuongDoi = 0;
        this.HanSuDung = '';
        this.SoLo = '';
        this.Dvt = 0;
        this.DonViTinh = '';
        this.GhiChu = '';
        this.SoLuongDeXuat = 0;
        this.GiaBan = 0;
        this.ThanhTien = 0;
        this.HuongXuLy = '';
        this.HangHoaKemTheoId = 0;
        this.MaHHKemTheo = '';
        this.TenHHKemTheo = '';        
        this.IsEnable_Duyet = false;
        this.IsVisible_Duyet = false;
        this.isDone = false;
        this.ThamChieu = '';
    }
    copy(item: DoiTraHangCt) {
        this.Id = item.Id;
        this.IdKh = item.IdKh;
        this.MaKH = item.MaKH;
        this.TenKH = item.TenKH;
        this.DoiTraHangId = item.DoiTraHangId;
        this.HangHoaId = item.HangHoaId;
        this.MaHH = item.MaHH;
        this.HanSuDung = item.HanSuDung;
        this.SoLo = item.SoLo;
        this.TenHH = item.TenHH;
        this.QuyCach = item.QuyCach;
        this.SoLuongDoi = item.SoLuongDoi;
        this.Dvt = item.Dvt;
        this.DonViTinh = item.DonViTinh;
        this.GhiChu = item.GhiChu;
        this.SoLuongDeXuat = item.SoLuongDeXuat;
        this.GiaBan = item.GiaBan;
        this.ThanhTien = item.ThanhTien;
        this.HuongXuLy = item.HuongXuLy;
        this.HangHoaKemTheoId = item.HangHoaKemTheoId;
        this.MaHHKemTheo = item.MaHHKemTheo;
        this.TenHHKemTheo = item.TenHHKemTheo;       
        this.IsEnable_Duyet = item.IsEnable_Duyet;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.isDone = item.isDone;
        this.ThamChieu = item.ThamChieu;
        
    }
}
export class HangBanKH extends BaseModel {
    Id: number
    HangHoaId: number
    MaHH: string
    TenHH: string
    Dvt: number
    DonViTinh: string
    IdKh: number
    MaKH: string
    TenKH: string
    SoPhieu: string
    SoLuong: number
    DonGia: number
    NgayTao: string
    GiaMin: number
    GiaMax: number
    GiaTB: number
    datHangId: number

    clear() {
        this.Id = 0;
        this.HangHoaId = 0;
        this.MaHH = '';
        this.TenHH = '';
        this.Dvt = 0;
        this.DonViTinh = '';
        this.IdKh = 0;
        this.MaKH = '';
        this.TenKH = '';
        this.SoPhieu = '';
        this.SoLuong = 0;
        this.DonGia = 0;
        this.NgayTao = '';
        this.GiaMin = 0;
        this.GiaMax = 0;
        this.GiaTB = 0;
        this.datHangId = 0;
    }

    copy(item: HangBanKH) {
        this.Id = item.Id;
        this.HangHoaId = item.HangHoaId;
        this.MaHH = item.MaHH;
        this.TenHH = item.TenHH;
        this.Dvt = item.Dvt;
        this.DonViTinh = item.DonViTinh;
        this.IdKh = item.IdKh;
        this.MaKH = item.MaKH;
        this.TenKH = item.TenKH;
        this.SoPhieu = item.SoPhieu;
        this.SoLuong = item.SoLuong;
        this.DonGia = item.DonGia;
        this.NgayTao = item.NgayTao;
        this.GiaMin = item.GiaMin;
        this.GiaMax = item.GiaMax;
        this.GiaTB = item.GiaTB;
        this.datHangId = item.datHangId;
    }

}

